import { onBeforeUnmount, ref } from 'vue';

function useDropdownVisibility(elementID?: string) {
  const isVisibleDropdown = ref(false);

  const toggleDropdown = (): void => {
    isVisibleDropdown.value = !isVisibleDropdown.value;
  };

  const hideDropdown = (event?: Event): void => {
    if (elementID) {
      const targetElement = document.getElementById(elementID);

      if (targetElement && event && targetElement.contains(event.target as HTMLElement)) return;
    }

    isVisibleDropdown.value = false;
  };

  const openDropdown = (): void => {
    isVisibleDropdown.value = true;
  };

  window.addEventListener('click', hideDropdown, false);

  onBeforeUnmount(() => {
    window.removeEventListener('click', hideDropdown, false);
  });

  return {
    isVisibleDropdown,
    toggleDropdown,
    hideDropdown,
    openDropdown,
  };
}

export default useDropdownVisibility;
